import PageHero from "@/components/common/PageHero";
import { caseStudies } from "@/components/sections/CaseStudies";
import FinalCTA from "@/components/sections/FinalCTA";
import Reveal from "@/components/common/Reveal";

const extra = [
  {
    slug: "verde-skin",
    name: "Verde Skin",
    industry: "Skincare • EU",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=900&q=80",
    metrics: [{ v: "+228%", l: "Revenue" }, { v: "4.6x", l: "ROAS" }, { v: "+92%", l: "Repeat" }],
    note: "Subscription funnel + retention engine.",
  },
  {
    slug: "kova-apparel",
    name: "Kova Apparel",
    industry: "Fashion • AUS",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=900&q=80",
    metrics: [{ v: "+612%", l: "Revenue" }, { v: "5.2x", l: "ROAS" }, { v: "+184%", l: "AOV" }],
    note: "International expansion playbook.",
  },
  {
    slug: "north-coffee",
    name: "North Coffee",
    industry: "F&B • USA",
    image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=900&q=80",
    metrics: [{ v: "+340%", l: "Subs" }, { v: "3.9x", l: "ROAS" }, { v: "1.6s", l: "LCP" }],
    note: "Subscription Shopify rebuild.",
  },
];

export default function CaseStudiesPage() {
  const all = [...caseStudies, ...extra];
  return (
    <main data-testid="case-studies-page">
      <PageHero
        eyebrow="Case Studies"
        title={<>Brands. Numbers. <span className="text-gradient">Proof.</span></>}
        subtitle="Hand-picked stories of Shopify brands we've helped scale across the US, UK, Europe, UAE & Australia."
      />
      <section className="py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {all.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.05}>
              <article className="group h-full overflow-hidden rounded-3xl bg-[#0A0A0C] border border-white/5 hover:border-blue-500/30 transition-all">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <div className="text-xs text-zinc-400 uppercase tracking-wider">{c.industry}</div>
                    <h3 className="font-display text-2xl font-extrabold text-white">{c.name}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <div className="grid grid-cols-3 gap-3">
                    {c.metrics.map((m) => (
                      <div key={m.l}>
                        <div className="font-display text-xl font-extrabold text-white">{m.v}</div>
                        <div className="text-[10px] text-zinc-500 uppercase tracking-wider mt-0.5">{m.l}</div>
                      </div>
                    ))}
                  </div>
                  <p className="mt-5 text-sm text-zinc-400 leading-relaxed">{c.note}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
      <FinalCTA />
    </main>
  );
}
